<template>
  <div>
    <ScheduleRow title="キックオフまで" color="black">
      <p>
        JavaScript を学ぶ前提として、HTML と CSS
        をしっかり勉強しておきましょう。
      </p>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <ArticleChapterLink article-id="pre_readme" />
        <ArticleChapterLink article-id="pre_todo" />
        <ArticleChapterLink article-id="pre_about_course" />
        <ArticleChapterLink article-id="kickoff_preinstall" />
        <ArticleChapterLink article-id="git_setup" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="キックオフ">
      <p>キックオフでは、学習の進め方の共有や JavaScript の導入を行います。</p>
      <p>Week 1 のゼミまでの教材では JavaScript の基礎を中心に学びます。</p>
      <p>
        これから何度も使っていくプログラミングの重要な概念がいくつもでてきます。
      </p>
      <div
        class="ScheduleTable__note article"
        data-title="キックオフで取り組んだ記事"
      >
        <ArticleChapterLink article-id="kickoff_start" />
        <ArticleChapterLink article-id="kickoff_sample_code" />
        <ArticleChapterLink article-id="pc_terminal" />
        <ArticleChapterLink article-id="kickoff_how_to_read_artcile" />
      </div>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <p>まずは、プログラミングの基礎的なことをパパッと学びましょう</p>
        <ArticleChapterLink article-id="js_basic_first_step" />
        <ArticleChapterLink article-id="js_basic_variables" />
        <ArticleChapterLink article-id="js_basic_operator" />
        <ArticleChapterLink article-id="js_basic_function" />
        <ArticleChapterLink article-id="js_basic_object" />
        <p>ここまできたら、レシピ「3の倍数」をやってみよう...！</p>
        <ArticleChapterLink article-id="recipe1_three" />
        <ArticleChapterLink article-id="recipe1_three_practice_1" />
        <p>
          ブラウザで JavaScript を使うためのプログラミングをここから学びます。
        </p>
        <ArticleChapterLink article-id="recipe1_counter" />
        <ArticleChapterLink article-id="recipe1_counter_practice_1" />
        <ArticleChapterLink article-id="js_dom_manipulation" />
        <ArticleChapterLink article-id="js_dom" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 1">
      <p>
        Week 1 のゼミでは JavaScript のデータ型とオブジェクトについて学びつつ<br />簡単なプログラムを作ります。
      </p>
      <p>
        Week 2 までの教材では JavaScript でページに変化を与える方法を学びます。
      </p>
      <p>例えばこんな感じ。</p>
      <MiniApp />
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <ArticleChapterLink article-id="js_dom_event" />
        <ArticleChapterLink article-id="recipe1_counter_practice_2" />
        <ArticleChapterLink article-id="recipe1_shape" />
        <ArticleChapterLink article-id="recipe1_shape_practice_1" />
        <ArticleChapterLink article-id="recipe1_shape_practice_2" />
        <ArticleChapterLink article-id="recipe1_stopwatch" />
        <p>
          もの足りない人は「Article」ページを見てレシピ1のまだやっていない問題に取り組みましょう。具体的にはこれらの問題に取り組んでないはずです。
        </p>
        <ArticleChapterLink article-id="recipe1_three_practice_2" />
        <ArticleChapterLink article-id="recipe1_three_practice_3" />
        <p>これらの問題は難しいので必ず取り組まなくてもかまいません。</p>
        <ArticleChapterLink article-id="recipe1_stopwatch_practice_1" />
        <ArticleChapterLink article-id="recipe1_stopwatch_practice_2" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 2">
      <p>
        Week 2
        のゼミでは自動販売機を作りながらプログラムを書くための考え方について学びます。
      </p>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <p>
          レシピでつくるメモアプリにはWebアプリケーションを作るための欠かせない考え方が入っています！必修です！
        </p>
        <ArticleChapterLink
          article-id="js_dom_manipulation_create_and_append"
        />
        <ArticleChapterLink article-id="recipe2_trello" />
        <ArticleChapterLink article-id="recipe2_trello_practice_1" />
        <ArticleChapterLink article-id="programming_brakedown" />
        <p>Week2のゼミで扱った「状態」についての復習です！</p>
        <ArticleChapterLink article-id="programming_state" />
        <p>今後は、「配列」を扱うことが増えてきます</p>
        <ArticleChapterLink article-id="js_basic_array" />
        <ArticleChapterLink article-id="recipe2_quiz" />
        <ArticleChapterLink article-id="recipe2_quiz_practice_1" />
        <ArticleChapterLink article-id="recipe2_quiz_practice_2" />
        <p>
          この発展問題は難しいので現時点で解ききることができなくても大丈夫でしょう
        </p>
        <ArticleChapterLink article-id="recipe2_trello_practice_2" />
      </div>

      <div class="ScheduleTable__note homework" data-title="課題">
        <p>ポートフォリオの作成。</p>
        <p>
          JavaScript を使いながら、自己紹介用のウェブサイトを作ってください。
        </p>
        <p>次回のゼミで発表会をします。</p>
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 3">
      <p>
        Week 3
        のゼミではメモアプリを作りながら良いプログラムを作るための考え方を身に付けます。また、Week
        2 の学習で制作したポートフォリオを発表します。
      </p>
      <div class="ScheduleTable__note event" data-title="イベント">
        <p>ポートフォリオ発表会です。</p>
      </div>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <p>Week2のゼミでも扱った配列を復習しましょう</p>
        <ArticleChapterLink article-id="js_basic_localStorage" />
        <ArticleChapterLink article-id="recipe2_trello_practice_3" />
        <p>この発展問題はWeek4のゼミでも取り組みます</p>
        <ArticleChapterLink article-id="recipe2_quiz_practice_3" />

        <p>Web API を使えるようになると世界が広がります。</p>
        <ArticleChapterLink article-id="recipe2_dog_api" />
        <ArticleChapterLink article-id="recipe2_dog_api_practice_1" />

        <ArticleChapterLink article-id="recipe2_dog_api_practice_2" />

        <p>
          もの足りない人は「Article」ページを見てレシピ2のまだやっていない問題に取り組みましょう。具体的にはこれらの問題に取り組んでないはずです。
        </p>

        <ArticleChapterLink article-id="recipe2_quiz_practice_4" />
        <ArticleChapterLink article-id="recipe2_dog_api_practice_3" />
        <p>これらの問題は難しいので必ず取り組まなくてもかまいません。</p>
        <ArticleChapterLink article-id="recipe2_dog_api_practice_4" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 4">
      <p>
        Week 4
        のゼミではより複雑なアプリケーションを作れるようになるために、React
        とをより実践的につかうためのツールについて学びます。
      </p>
    </ScheduleRow>
    <ScheduleRow title="Week 5">
      <p>React を使ううえで大切な概念であるコンポーネントについて学びます。</p>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <ArticleChapterLink article-id="git_basic" />
        <ArticleChapterLink article-id="git_branch" />
        <ArticleChapterLink article-id="git_github_develop" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 6">
      <p>git と GitHub の使い方を学びます。</p>
      <div class="ScheduleTable__note homework" data-title="課題">
        <p>デモチームアプリの作成。</p>
        <p>
          チームで協力して React
          の機能を活かしたアプリケーションを作ってください。
        </p>
        <p>２週間後のゼミで発表会をします。</p>
      </div>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <p>Firebase を使うことで世界が広がります！</p>
        <ArticleChapterLink article-id="firebase_setup_with_react" />
        <p>オリジナルアプリのアイデアを探します。</p>
        <ArticleChapterLink article-id="how_to_make_idea" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 7">
      <p>Firebase を使った開発を学びます。</p>
      <p>
        ログイン機能やデータベースを使ったデータの保存などができるようになります。
      </p>
      <div
        class="ScheduleTable__note article"
        data-title="今週の記事とオススメの取り組み順"
      >
        <p>デモチームアプリが完成したら公開してみましょう！</p>
        <ArticleChapterLink article-id="firebase_deploy" />
        <p>
          オリジナルアプリのアイデアを元にアプリケーションを設計してみましょう
        </p>
        <ArticleChapterLink article-id="how_to_design_application" />
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 8">
      <p>
        Week 8
        のゼミでは、チームで開発するオリジナルアプリのアイデアを決定して、今後の開発についてチームで話し合います。
      </p>
      <div class="ScheduleTable__note event" data-title="イベント">
        デモチームアプリ発表会です。
      </div>
    </ScheduleRow>
    <ScheduleRow title="Week 9 - 11">
      <p>ゼミ形式ではなくチームで集まって開発を行います。</p>
      <div class="ScheduleTable__note homework" data-title="課題">
        <p>GSDC に向けたアプリをチームで開発してください。</p>
        <p>
          メンターとミーティングを重ねながら、一歩ずつ開発を進めていきます。
        </p>
      </div>
    </ScheduleRow>
    <ScheduleRow title="GSDC" end>
      <div class="ScheduleTable__note event" data-title="イベント">
        <p>３ヶ月の集大成、GSDC です。</p>
        <p>自分たちの作ったアプリをたくさんの人に見てもらいましょう！</p>
      </div>
    </ScheduleRow>
  </div>
</template>

<script setup>
import ScheduleRow from "@/components/schedule/ScheduleRow.vue"
import MiniApp from "@/components/schedule/MiniApp.vue"
import ArticleChapterLink from "@/components/article/ArticleChapterLink.vue"
</script>

<style lang="scss" scoped>
.ScheduleTable__note {
  position: relative;
  margin-top: 2rem;
  padding: 1rem;
  border: 1px solid;
  &:before {
    padding: 0.25rem;
    position: absolute;
    top: 0;
    left: 1rem;
    transform: translate(0, -60%);
    background: var(--white);
    font-weight: bold;
    content: attr(data-title);
  }
  &.homework {
    border-color: var(--secondary);
    color: var(--secondary);
  }
  &.event {
    border-color: var(--tertiary);
    color: var(--tertiary);
  }
  &.article {
    border-color: var(--primary-light);
    color: var(--primary-light);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
